<template>
    <div v-loading="loading">
        <div v-if="!loading && !plano">
            <el-alert title="Planejamento não encontrado." type="warning" :closable="false" show-icon />
            <router-link to="/admin/planejamento" class="u-mt-10 u-display-inline-block">
                <el-button>Voltar à lista</el-button>
            </router-link>
        </div>

        <div v-if="!loading && plano">
            <h2 class="u-mt-10">Planejamento Semanal</h2>

            <el-row :gutter="10" class="cabecalho u-mt-10">
                <el-col :xs="24" :sm="12" :md="12">
                    <label>Professor</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ plano.user ? plano.user.name : '-' }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <label>Instituição</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ plano.instituicao ? plano.instituicao.nome : '-' }}
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="6" :md="6">
                    <label>Curso</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ plano.curso ? plano.curso.nome : (plano.turma && plano.turma.curso ? plano.turma.curso.nome : '') }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <label>Período da semana</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ $moment(plano.data_inicio).format('DD/MM/YYYY') }} a {{ $moment(plano.data_fim).format('DD/MM/YYYY') }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="4" :md="4">
                    <label>Modelo</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ $CONSTANTS.TIPO_MODELO_PLANEJAMENTO[plano.tipo_modelo] || plano.tipo_modelo }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="4" :md="4">
                    <label>Tipo de AC</label>
                    <div class="style-input" style="background-color: #ebebeb !important;">
                        {{ formatAcTipo(plano.dados && plano.dados.ac_tipo) }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="4" :md="4">
                    <label>Status</label>
                    <div style="margin-top: 4px;">
                        <el-tag :type="statusTagType(plano.status)" size="medium">
                            {{ $CONSTANTS.STATUS_PLANEJAMENTO[plano.status] || plano.status }}
                        </el-tag>
                    </div>
                </el-col>
            </el-row>

            <hr class="u-mt-15" />

            <h3>Conteúdo do plano</h3>
            <renderer :dados="plano.dados" :tipo="plano.tipo_modelo" />

            <hr class="u-mt-15" />

            <h3>Comentários</h3>

            <div v-if="!plano.comentarios || plano.comentarios.length === 0" class="u-mt-10">
                <em>Nenhum comentário até o momento.</em>
            </div>
            <div v-else class="u-mt-10">
                <div v-for="c in plano.comentarios" :key="c.id" class="comentario">
                    <div class="comentario-meta">
                        <strong>{{ c.user ? c.user.name : '—' }}</strong>
                        <span class="comentario-data">{{ $moment(c.created_at).format('DD/MM/YYYY HH:mm') }}</span>
                    </div>
                    <div class="comentario-texto">{{ c.texto }}</div>
                </div>
            </div>

            <div v-if="podeComentar" class="u-mt-20">
                <h4>Adicionar comentário</h4>
                <el-input
                    type="textarea"
                    :rows="4"
                    v-model="novoComentario"
                    placeholder="Escreva seu comentário ou sugestão para o professor..."
                />
                <div class="u-text-right u-mt-10">
                    <el-button :loading="enviandoComentario" type="primary" @click="enviarComentario">
                        Enviar comentário
                    </el-button>
                </div>
            </div>

            <hr class="u-mt-15" />

            <div class="u-text-right">
                <el-button
                    v-if="podeComentar"
                    :type="plano.status == 4 ? 'warning' : 'success'"
                    :loading="validando"
                    @click="validarPlanejamento"
                >
                    {{ plano.status == 4 ? 'Desfazer Validação' : 'Validar Planejamento' }}
                </el-button>
                <router-link to="/admin/planejamento" class="u-ml-10">
                    <el-button>Voltar</el-button>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import renderer from "./renderer"

export default {
    components: { renderer },
    data: () => ({
        loading: true,
        plano: null,
        novoComentario: '',
        enviandoComentario: false,
        validando: false,
    }),
    computed: {
        podeComentar() {
            const tipo = Number(this.$store.state.user.tipo);
            return [3, 4, 7].includes(tipo);
        }
    },
    mounted() {
        this.loadPlano();
    },
    methods: {
        loadPlano() {
            this.loading = true;
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-pedagogico/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                if (response.data && response.data.erro) {
                    this.$message({ message: response.data.erro.text, type: 'warning', duration: 5000 });
                    this.plano = null;
                } else {
                    this.plano = response.data;
                }
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                this.$store.commit('throwException', error);
            });
        },
        formatAcTipo(val) {
            if (val === 'escola') return 'AC na Escola';
            if (val === 'home_office') return 'AC em Home Office';
            return '—';
        },
        statusTagType(s) {
            s = Number(s);
            if (s === 4) return 'success';
            if (s === 3) return 'warning';
            return 'info';
        },
        validarPlanejamento() {
            this.validando = true;
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-pedagogico/validar/${this.plano.id}`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.validando = false;
                if (response.data && response.data.erro) {
                    this.$message({ message: response.data.erro.text, type: 'warning', duration: 5000 });
                } else {
                    const msg = response.data.status == 4 ? 'Planejamento validado com sucesso!' : 'Validação desfeita com sucesso!';
                    this.$message({ message: msg, type: 'success', duration: 4000 });
                    this.loadPlano();
                }
            }).catch((error) => {
                this.validando = false;
                this.$store.commit('throwException', error);
            });
        },
        enviarComentario() {
            if (!this.novoComentario || !this.novoComentario.trim()) {
                this.$message({ message: 'Texto do comentário é obrigatório.', type: 'warning', duration: 4000 });
                return;
            }

            this.enviandoComentario = true;

            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-pedagogico/storeComentario/${this.plano.id}`,
                { texto: this.novoComentario },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.enviandoComentario = false;
                if (response.data && response.data.erro) {
                    this.$message({ message: response.data.erro.text, type: 'warning', duration: 5000 });
                } else {
                    this.$message({ message: 'Comentário enviado!', type: 'success', duration: 4000 });
                    this.novoComentario = '';
                    this.loadPlano();
                }
            }).catch((error) => {
                this.enviandoComentario = false;
                this.$store.commit('throwException', error);
            });
        }
    }
}
</script>
<style scoped>
.cabecalho label {
    color: #606266;
    font-size: 0.9em;
}
.style-input {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 6px 12px;
    line-height: 1.5;
}
.comentario {
    background-color: #f5f5f5;
    border-left: 3px solid #1976d2;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
}
.comentario-meta {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    font-size: 0.9em;
}
.comentario-data { color: #888; }
.comentario-texto { white-space: pre-wrap; }
</style>
